import { parse, stringify } from "query-string"
import { pick } from "ramda"
import React, { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import Colors from "../../theme/Colors"
import {
  NotDesktop,
  OnDesktop,
  onPhone,
  onDesktop,
  onTablet,
  OnPhone,
  NotPhone,
} from "../../theme/MediaQueries"
import { WidgetTitleText } from "../../theme/Typography"
import CheckItem from "../CheckItem"
import { AddonContainer, ArrowDown, WidgetTitleContainer } from "./styles"

const Container = styled.div``

const WidgetTitle = styled.div`
  ${WidgetTitleText};
  color: ${Colors.blue};
`
const CheckItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  ${onPhone} {
    width: 90%;
    max-width: 240px;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 10px 0;
  }
  ${onTablet} {
    margin: 4px 0;
  }
`

const WidgetIframe = styled.iframe`
  border: 0;
  background-color: transparent;
  width: 100%;
  height: 100%;
  margin-top: -10px;
  min-height: calc(100vh - 81px - 55px - 10px - 10px - 48px - 56px - 5px);
`

const AdaptedWidgetTitleContainer = styled(WidgetTitleContainer)`
  z-index: 200;
  padding: 8px 0;
  width: 100%;
  background-color: ${Colors.lightestgrey};
  ${onDesktop} {
    background-color: rgb(${Colors.rgb.lightestgrey}, 0.6);
  }
`

const useStyledIframe = iframe =>
  useEffect(() => {
    if (iframe) {
      var style = document.createElement("style")
      style.textContent = "body {  background-color: transparent; }"

      const appendStyled = contentDocument => () => {
        if (contentDocument) {
          contentDocument.head.appendChild(style)
        }
      }

      iframe.current.addEventListener(
        "load",
        appendStyled(iframe.current.contentDocument)
      )
    }
  })

const Widget = () => {
  const iframe = useRef(null)
  const [query, setQuery] = useState(null)
  useEffect(() => {
    setQuery(
      pick(
        [
          "amount",
          "purpose",
          "productId",
          "term",
          "configuration",
          "bid",
          "sid",
        ],
        parse(window.location.search)
      )
    )
  }, [])

  return (
    <Container>
      <AddonContainer>
        <AdaptedWidgetTitleContainer>
          <OnPhone>
            <WidgetTitle>Kreditvergleich</WidgetTitle>
          </OnPhone>
          <NotPhone>
            <WidgetTitle>
              Kreditvergleich – unabhängig und kundenorientiert
            </WidgetTitle>
          </NotPhone>
        </AdaptedWidgetTitleContainer>
        <ArrowDown color={Colors.lightestgrey} style={{ zIndex: 200 }} />
      </AddonContainer>
      <AddonContainer style={{ marginTop: -10 }}>
        <WidgetTitleContainer
          style={{
            backgroundColor: Colors.lightestblue,
            zIndex: 100,
            padding: 0,
            width: "100%",
          }}
        >
          <CheckItemsContainer>
            <CheckItem>
              <OnDesktop>100% kostenlos für Sie</OnDesktop>
              <NotDesktop>100% kostenlos</NotDesktop>
            </CheckItem>
            <CheckItem>Ohne Schufa-Eintrag</CheckItem>
            <CheckItem>Unverbindliche Angebote</CheckItem>
          </CheckItemsContainer>
        </WidgetTitleContainer>
        <ArrowDown color={Colors.lightestblue} style={{ zIndex: 200 }} />
      </AddonContainer>
      {/* <AddonContainer style={{ marginTop: -10 }}>
        <WidgetTitleContainer
          style={{
            backgroundColor: "#FAFAFA",

            width: "100%",
          }}
        >
          <WidgetTitle>Ihre Kreditanfrage</WidgetTitle>
        </WidgetTitleContainer>
      </AddonContainer> */}
      {query && (
        <WidgetIframe
          ref={iframe}
          src={`${process.env.OFFERS_URL}?${stringify(query)}`}
        />
      )}
    </Container>
  )
}
Widget.propTypes = {}

Widget.defaultProps = {}

export default Widget
